// @ts-nocheck
import React from 'react'
import { t } from 'ttag'

import { Icon, SearchIcon } from 'components/shared/Icon/Icon'

import styles from './NoSearchResults.module.scss'

export const NoSearchResults = () => (
  <div className={styles.noResults}>
    <Icon className={styles.icon} icon={SearchIcon} size={58} />
    <h2 className={styles.title}>{t`No results found.`}</h2>
    <p
      className={styles.text}
    >{t`We couldn’t find what you searched for.\nTry searching again.`}</p>
  </div>
)
